import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-5 p-5 rounded-b-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-6" }, null, -1)
const _hoisted_3 = { class: "flex items-center space-x-5" }
const _hoisted_4 = { class: "relative flex-shrink-0 w-20 h-14" }
const _hoisted_5 = { class: "absolute inset-0 inline-flex items-center justify-center bg-gray-blue-500 dark:bg-gray-bluer-400 rounded-sm text-xl lg:text-3xl font-bold text-gray-bluer-200 uppercase" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-gray-bluer-300 text-sm truncate" }, "Go Back", -1)
const _hoisted_7 = { class: "flex justify-end flex-grow space-x-2 text-xs font-medium" }
const _hoisted_8 = { class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-red-500" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "w-6"
}
const _hoisted_12 = { class: "flex items-center space-x-5" }
const _hoisted_13 = { class: "relative flex-shrink-0 w-20 h-14" }
const _hoisted_14 = { class: "absolute inset-0 inline-flex items-center justify-center bg-gray-blue-500 dark:bg-gray-bluer-400 rounded-sm text-xl lg:text-3xl font-bold text-gray-bluer-200 uppercase" }
const _hoisted_15 = { class: "font-bold text-gray-bluer-300 text-sm truncate" }
const _hoisted_16 = {
  key: 1,
  class: "flex flex-grow justify-end space-x-2 text-xs font-medium"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "flex items-center p-3 space-x-5 w-full"
}
const _hoisted_19 = ["checked", "onClick"]
const _hoisted_20 = { class: "flex items-center space-x-5 truncate" }
const _hoisted_21 = { class: "relative flex-shrink-0 w-20 h-14" }
const _hoisted_22 = {
  key: 1,
  class: "absolute inset-0 inline-flex items-center justify-center bg-gray-blue-500 dark:bg-gray-bluer-400 rounded-sm text-sm font-bold text-gray-bluer-200 uppercase"
}
const _hoisted_23 = { class: "leading-none" }
const _hoisted_24 = { class: "font-bold text-gray-bluer-300 text-sm" }
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 1,
  class: "block text-xs text-gray-bluer-100 font-medium"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  class: "flex flex-grow justify-end space-x-2 text-xs font-medium pl-5",
  style: {"min-width":"0"}
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]

import { useStore } from "vuex";
import { load }     from "../mixin";


export default /*#__PURE__*/_defineComponent({
  props: {
        searchAllMode: {
            type:     Boolean,
            default:  false,
            required: false
        },
    },
  emits: [ 'preview', 'download', 'replace' ],
  setup(__props, { emit }) {

const props = __props



const store = useStore();

const {
          backPath,
          searchResults,
          allFilesSelected,
          selectedFiles,
          mode,
          activeFile,
          filteredFiles,
          setPath,
          setAllFilesSelected,
          setSelectedFiles,
          setFile,
          setModal,
          deleteFolder,
          deleteFile,
          selectFile,
          toggleAllFilesSelection,
          toggleFileSelection
      } = load( store );



return (_ctx: any,_cache: any) => {
  const _component_x_icon = _resolveComponent("x-icon")!
  const _component_x_popper = _resolveComponent("x-popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(backPath) && __props.searchAllMode === false)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "flex items-center cursor-pointer p-3 space-x-3 w-full border-2 border-gray-blue-200 dark:border-gray-bluer-400 rounded-sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setPath)(_unref(backPath))))
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_x_icon, {
                  icon: "fontawesome.ellipsis",
                  class: "w-12 h-8"
                })
              ])
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_x_icon, {
                icon: "fontawesome.chevron-right",
                class: "h-5 w-5"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredFiles), (file, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["flex items-center justify-between border-2 rounded-sm", {
                'border-blue': _unref(selectedFiles).indexOf(file.id) !== -1 || ( _unref(activeFile) && _unref(activeFile).id === file.id ),
                'border-gray-blue-200 dark:border-gray-bluer-400': _unref(selectedFiles).indexOf( file.id ) === -1 && (!_unref(activeFile) || _unref(activeFile).id !== file.id),
                'cursor-pointer': _unref(mode) === 'field'
            }]),
        onClick: ($event: any) => (_unref(selectFile)(file))
      }, [
        (file.type === 'folder')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "flex items-center cursor-pointer p-3 space-x-3 w-full",
              onClick: ($event: any) => (_unref(setPath)(file.path))
            }, [
              (_unref(mode) !== 'field')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_x_icon, {
                      icon: "fontawesome.folder",
                      class: "w-12 h-8"
                    })
                  ])
                ]),
                _createElementVNode("span", _hoisted_15, _toDisplayString(file.name), 1)
              ]),
              (_unref(mode) !== 'field')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_x_popper, {
                      arrow: "",
                      hover: "",
                      content: "Delete"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-red-500",
                          onClick: _withModifiers(($event: any) => (_unref(deleteFolder)( file.path )), ["prevent"])
                        }, [
                          _createVNode(_component_x_icon, {
                            icon: "fontawesome.trash",
                            "fa-type": "fas",
                            class: "h-5 w-5"
                          })
                        ], 8, _hoisted_17)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_10))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (_unref(mode) !== 'field')
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "checkbox",
                    class: "focus:ring-theme-500 h-4 w-4 text-theme-600 border-gray-300 rounded dark:bg-gray-bluer-800 dark:border-gray-bluer-500",
                    checked: _unref(selectedFiles).indexOf(file.id) !== -1,
                    onClick: ($event: any) => (_unref(toggleFileSelection)( file, $event.target.checked ))
                  }, null, 8, _hoisted_19))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  (file.is_image)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "absolute inset-0 bg-no-repeat bg-center bg-cover rounded-sm",
                        style: _normalizeStyle(`background-image: url('${file.url}')`)
                      }, null, 4))
                    : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(file.file_name.split( '.' ).pop()), 1))
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(file.name || file.file_name), 1),
                  (_unref(mode) !== 'field')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: file.url,
                        target: "_blank",
                        class: "block text-xs text-gray-bluer-100 font-medium hover:text-theme-500 transition duration-150 ease-in-out"
                      }, _toDisplayString(file.url), 9, _hoisted_25))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(file.url), 1))
                ])
              ]),
              (file.age_status)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_component_x_popper, {
                      arrow: "",
                      hover: "",
                      content: file.age_status.message
                    }, {
                      default: _withCtx(() => [
                        (file.age_status.status == 'expired')
                          ? (_openBlock(), _createBlock(_component_x_icon, {
                              key: 0,
                              icon: "fontawesome.exclamation-triangle",
                              "fa-type": "fas",
                              class: "h-5 w-5",
                              style: {"color":"red"}
                            }))
                          : (_openBlock(), _createBlock(_component_x_icon, {
                              key: 1,
                              icon: "fontawesome.exclamation-triangle",
                              "fa-type": "fas",
                              class: "h-5 w-5",
                              style: {"color":"orange"}
                            }))
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_28, [
                (_unref(store).state.media.previewsEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(_component_x_popper, {
                        arrow: "",
                        hover: "",
                        content: "Preview"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: "#",
                            class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-theme-500",
                            onClick: _withModifiers(($event: any) => (emit( 'preview', file )), ["prevent"])
                          }, [
                            _createVNode(_component_x_icon, {
                              icon: "fontawesome.eye",
                              "fa-type": "fas",
                              class: "h-5 w-5"
                            })
                          ], 8, _hoisted_30)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createVNode(_component_x_popper, {
                    arrow: "",
                    hover: "",
                    content: "Download"
                  }, {
                    default: _withCtx(() => [
                      (_unref(mode) !== 'field')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-theme-500",
                            onClick: _withModifiers(($event: any) => (emit( 'download', file )), ["prevent"])
                          }, [
                            _createVNode(_component_x_icon, {
                              icon: "fontawesome.arrow-down-to-line",
                              "fa-type": "fas",
                              class: "h-5 w-5"
                            })
                          ], 8, _hoisted_31))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_x_popper, {
                    arrow: "",
                    hover: "",
                    content: "Replace"
                  }, {
                    default: _withCtx(() => [
                      (_unref(mode) !== 'field')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-theme-500",
                            onClick: _withModifiers(($event: any) => (emit( 'replace', file )), ["prevent"])
                          }, [
                            _createVNode(_component_x_icon, {
                              icon: "fontawesome.arrow-right-arrow-left",
                              "fa-type": "fas",
                              class: "h-5 w-5"
                            })
                          ], 8, _hoisted_32))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_x_popper, {
                    arrow: "",
                    hover: "",
                    content: "Delete"
                  }, {
                    default: _withCtx(() => [
                      (_unref(mode) !== 'field')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-red-500",
                            onClick: _withModifiers(($event: any) => (_unref(deleteFile)( file )), ["prevent"])
                          }, [
                            _createVNode(_component_x_icon, {
                              icon: "fontawesome.trash",
                              "fa-type": "fas",
                              class: "h-5 w-5"
                            })
                          ], 8, _hoisted_33))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ])
            ]))
      ], 10, _hoisted_9))
    }), 128))
  ]))
}
}

})